import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import MDInput from "components/MDInput";
import Pagination from "@mui/material/Pagination";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Card,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";
import MenuItem from "@mui/material/MenuItem";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

function DeviceInventory() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
const [filterStatus, setFilterStatus] = useState("ALL"); 

  const [mappingDetails, setMappingDetails] = useState({
    doctorid: "",
    patientid: "",
    ccid: "",
    date: "",
  });

  const [mappingList, setMappingList] = useState([]);
  const navigate = useNavigate();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

  // 🔹 Add Modal
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);



  // 🔹 Delete Modal
  const handleOpenDeleteModal = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };
  const handleCloseDeleteModal = () => setDeleteModal(false);

  // 🔹 Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMappingDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  // 🔹 Delete Mapping
  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const encryptedData = encryptBody({ id: selectedId }, secretKey);

      const response = await axios.post("/api/device/delete", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
        toast.success(decryptedResponse.message || " Device deleted successfully!");
        setDeleteModal(false);
        fetchMapping();
      }
    } catch (error) {
      toast.error(error.message || "Failed to delete Device.");
    } finally {
      setLoading(false);
    }
  };

  const fetchMapping = async (pageNumber = 1) => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/device/all`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMappingList(decryptedData.content || []);
         setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error fetching mappings:", error);
    //   toast.error("Failed to fetch mappings.");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchMapping();
  }, []);
 const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchMapping(currentPage);
    }
  }, [searchTerm, currentPage]);
  
  
  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
       console.log("Search term before API call:", searchTerm);
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
      const payload = {};

if (searchTerm && searchTerm.trim().length > 0) {
  payload.searchTerm = searchTerm.trim();
}

if (filterStatus && filterStatus !== "ALL") {
  payload.allotmentStatus = filterStatus;
}

const requestBody = encryptBody(payload, secretKey);

   
      const response = await axios.post(`/api/device/searchByCcid/${userid}`, requestBody, {
        params: { page: Math.max(0, pageNumber - 1) },  
            headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Search Response:", decryptedData); 
        setMappingList(decryptedData.content || []);
        setCurrentPage(decryptedData.number + 1);
        setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching :", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
  searchData(currentPage);
}, [searchTerm, filterStatus, currentPage]);

  // Loader Animation
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MedicalAbstractBackground/>
      {/* Loader */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:"#1A237E",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
 <MDBox mt={1} p={1} display="flex"  alignItems="center">
      <MDTypography variant="h5" sx={{ flex: 1 }}>
       Device Inventory
  </MDTypography>
  <MDBox sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
           <MDInput
                 placeholder="Search Device Name Device Type Model Number"
                 variant="outlined"
                 fullWidth
                 value={searchTerm}
                 onChange={(e) => setSearchTerm(e.target.value)}
                 sx={{
                   maxWidth: "400px",
                   backgroundColor: "#fff",
                   borderRadius: "8px",
                 }}
                 InputProps={{
                   startAdornment: (
                     <InputAdornment position="start">
                       <IconButton size="small">
                         <SearchIcon />
                       </IconButton>
                     </InputAdornment>
                   ),
                 }}
               />
                 </MDBox>
                 <MDBox ml={2}>
  <MDInput
    select
    value={filterStatus}
    onChange={(e) => {
      setFilterStatus(e.target.value);
      setCurrentPage(1);
    }}
    sx={{
      width: "160px",          // reduced width
      backgroundColor: "#fff",
      borderRadius: "6px",     // slightly smaller curve
      height: "44px",          // reduced height
      "& .MuiInputBase-root": {
        height: "44px",
      },
      "& .MuiInputBase-input": {
        height: "44px",
        padding: "0 10px",     // reduced side padding
        fontSize: "14px",      // smaller text
        display: "flex",
        alignItems: "center",
      },
      "& fieldset": {
        borderRadius: "6px",
      },
    }}
  >
    <MenuItem value="ALL">All Device</MenuItem>
    <MenuItem value="ALLOTTED">Device Allotted</MenuItem>
    <MenuItem value="NOT_ALLOTTED">Device Not Allotted</MenuItem>
  </MDInput>
</MDBox>


        <MDBox sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>


          <MDButton
            variant="gradient"
            onClick={() => navigate("/RegisterDevice")}
            sx={{
              background: "#1A237E",
              color: "#fff",
              "&:hover": {
                background: "#1A237E",
              },
            }}
          >
            Register Device
          </MDButton>
       
    </MDBox>
   

      </MDBox>
     

      {/* Table */}
      <MDBox sx={{ overflowX: "auto", width: "100%" }}>
         <TableContainer component={Paper} sx={{ mt: 3, border: "1px solid #ddd", borderRadius: "8px", boxShadow: "2px 4px 10px rgba(0,0,0,0.1)" }}>
       
    <Table sx={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#1A237E"}}>
                {[ "Device Allotted","Device Id", "Device Name", "Device Type",  "Manufacturer", "Model Number","Serial Number","Description","Created Date","Care Coordinator Name","Actions"].map((header, index) => (
                  <TableCell
                    key={index}
                   sx={{
                 color: "#fff",
                fontWeight: "600",  
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "7px",
  minWidth: index === 0 ? "200px" : "100px",
width: index === 0 ? "315px" : "195px",

                whiteSpace: "nowrap",  // Prevent breaking into multiple lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}

       
  </TableRow>

            <TableBody>
              {mappingList.length > 0 ? (
                mappingList.map((mapping, index) => (
                  <TableRow key={index}>
                 <TableCell
  sx={{
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",
    cursor: "pointer",
  }}
>
  <Tooltip
    title={
      mapping?.alloted
        ? `Device alloted to ${mapping?.patientFirstName || ""} ${mapping?.patientLastName || ""}`
        : "Device not alloted"
    }
    arrow
   componentsProps={{
    tooltip: {
      sx: {
        backgroundColor: "#f9fafb", // light background
        color:"#1A237E",           // dark gray text
        fontSize: "13px",
        fontWeight: 600,            // 👈 slightly bold
        border: "1px solid #e5e7eb",
        boxShadow: "0px 6px 14px rgba(0,0,0,0.08)",
        borderRadius: "8px",
        padding: "8px 12px",
      },
    },
    arrow: {
      sx: {
        color: "#f9fafb",
      },
    },
  }}
  >
    <span style={{ cursor: "pointer" }}>
      <Checkbox
        checked={Boolean(mapping?.alloted)}
        disabled
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxIcon />}
        sx={{
          pointerEvents: "none", // 👈 prevents interaction but keeps cursor
          color: "#1A237E",
          "&.Mui-checked": {
            color: "#1A237E",
          },
        }}
      />
    </span>
  </Tooltip>
</TableCell>

                <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.devicecode}
                    </TableCell> 
                <TableCell
  sx={{
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",
    cursor: "pointer",
    textDecoration: "underline",
    color: "blue",
  }}
  onClick={() => navigate(`/ViewDeviceData/${mapping?.id}`)}
>
  {mapping?.devicename}
</TableCell>


                    <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping?.devicetype} 
                    </TableCell>
                    {/* <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.ccid}
                    </TableCell> */}
                    <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.manufacturer}
                    </TableCell>
                     <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.modelnumber}
                    </TableCell>
                      <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.serialnumber}
                    </TableCell>
                      <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.description}
                    </TableCell>
                        <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.createdat}
                    </TableCell>
                     <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.ccName}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center", border: "1px solid #ddd" }}>
                     
                      <IconButton color="default" onClick={() => handleOpenDeleteModal(mapping.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    sx={{ border: "1px solid #ddd", padding: "12px", fontStyle: "italic", color: "gray" }}
                  >
                    No Data Available.
                  </TableCell>
                </TableRow>
              )}
              
            </TableBody>
                        </TableHead>

            <Box mt={2} display="flex" justifyContent="center">
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="success"
                         sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "4px",
                  color: "#1A237E",          // Text color
                  borderColor: "#1A237E",    // Border color if outlined
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#1A237E", // Selected background
                  color: "#fff",                 // Selected text color
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#1A237E", // Slight hover effect
                },
              }}
                      />
                    </Box>
          </Table>
        </TableContainer>
      </MDBox>

      {/* Delete Modal */}
      <Modal open={deleteModal} onClose={handleCloseDeleteModal}>
        <Card sx={{ width: "400px", padding: 4, margin: "auto", mt: 15, textAlign: "center" }}>
          <MDTypography sx={{ mb: 3, fontSize: "16px", fontWeight: "bold" }}>
            Are you sure you want to delete this Device Details?
          </MDTypography>
          <MDBox display="flex" justifyContent="space-around">
            <MDButton variant="gradient" onClick={handleDelete} sx={{ background: "red", color: "#fff" }}>
              Delete
            </MDButton>
            <MDButton
              variant="gradient"
              onClick={handleCloseDeleteModal}
              sx={{ background: "#1A237E", color: "#fff" }}
            >
              Cancel
            </MDButton>
          </MDBox>
        </Card>
      </Modal>
    </DashboardLayout>
  );
}

export default DeviceInventory;
